import './App.css';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import { useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import Sketch from '@uiw/react-color-sketch';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputGroup from 'react-bootstrap/InputGroup';
import Badge from 'react-bootstrap/Badge';
import { FaClipboard } from "react-icons/fa";
import { FaClipboardCheck } from "react-icons/fa";

function FormInfo() {

  const [validated, setValidated] = useState(false);
  const [copied, setCopied] = useState(false);

  const [embarkIdInvalid, setEmbarkIdInvalid] = useState(false);
  const [urlGenerated, setUrlGenerated] = useState(null);
  const [formData, setFormData] = useState({
    embarkId: "",
    textColor: "#000000",
    backgroundColor: "#ff0000",
    borderColor: "#ff0000",
    borderWidth: "1",
    fontFamily: "",
    leaderboard: "ranked"
  })

  const onClickBtn = (event) => {
    setEmbarkIdInvalid(false);
    let urlOptional = "";
    Object.keys(formData).forEach(key => {
      if (formData[key] && key != "embarkId"){
        urlOptional += "&" + key + "=" + (key.toLowerCase().includes("color") ? formData[key].slice(1) : formData[key]);
      }
    });

    

    const form = event.currentTarget;
    let regex = /^([A-Za-z0-9-_.]){0,16}#[0-9]{4}$/i;
    const testRegex = !regex.test(formData.embarkId);
    if (form.checkValidity() === false || testRegex) {
      if (testRegex){
        setEmbarkIdInvalid(true);
      }
      event.preventDefault();
      event.stopPropagation();
    } else {
    setValidated(true);
    let urlMandatory = "embarkIdName=" + formData.embarkId.substring(0, formData.embarkId.length-5).toLowerCase() + "&embarkIdNumber=" + formData.embarkId.substring(formData.embarkId.length-4, formData.embarkId.length);
    let baseUrl = "http://the-finals-rank-overlay.nykho.fr" + (formData.leaderboard === "worldTour" ? "/world-tour" : "") + "?";
    setUrlGenerated(baseUrl + urlMandatory + urlOptional)
  }
  };

  function copyToClipboard() {
    var copyText = document.getElementById("finalUrl");
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(copyText.value);
    setCopied(true);
  }
  
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});
  return (
    <Container >
      <Form noValidate validated={validated}>
        <Form.Group className="mb-3" controlId="form.embarkId">
            <Form.Label>Embark ID (required)</Form.Label>
            <Form.Control required type="text" placeholder="YourUsername#0000" 
            value={formData.embarkId}
            onChange={(e) => setFormData({...formData, embarkId: e.target.value})}
            />
        </Form.Group>
        {embarkIdInvalid && <Alert key={'alert'} variant={'danger'}>
          Your Embark ID is invalid, please rectify to match this format : YourUsername#0000
        </Alert>}
        <Row className="justify-content-md-center">
          <Col>
            <Form.Group className="mb-3 col-xs-2 mx-auto text-center justify-content-lg-center" controlId="form.textColor">
                <Form.Label>Text color</Form.Label>
                <Sketch
                  style={{ marginLeft: 'auto', marginRight: 'auto' }}
                  color={formData.textColor}
                  onChange={(color) => setFormData({...formData, textColor: color.hexa})}
                />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3 col-xs-2 mx-auto text-center justify-content-lg-center" controlId="form.backgroundColor">
                <Form.Label>Background color</Form.Label>
                <Sketch
                  style={{ marginLeft: 'auto', marginRight: 'auto' }}
                  color={formData.backgroundColor}
                  onChange={(color) => setFormData({...formData, backgroundColor: color.hexa})}
                />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3 col-xs-2 mx-auto text-center justify-content-lg-center" controlId="form.backgroundColor">
                <Form.Label>Border color and size</Form.Label>
                <Sketch
                  style={{ marginLeft: 'auto', marginRight: 'auto' }}
                  color={formData.borderColor}
                  onChange={(color) => setFormData({...formData, borderColor: color.hexa})}
                />
                <Form.Range style={{ width:"200px", marginTop: "10px"  }} 
                  min="0" max="10" step="1" 
                  value={formData.borderWidth} 
                  onChange={(e) => setFormData({...formData, borderWidth: e.target.value})} 
                />
            </Form.Group>
          </Col>
        </Row>
        <Form.Group className="mb-3" controlId="form.fontFamily">
            <Form.Label>Font family (must be installed on your computer)</Form.Label>
            <Form.Control type="text" placeholder="Arial" value={formData.fontFamily} 
            onChange={(e) => setFormData({...formData, fontFamily: e.target.value})} />
        </Form.Group>
        <Form.Group className="mb-3" controlId="form.fontFamily">
        <Form.Label>Leaderboard</Form.Label>
          <Form.Select onChange={(e) => setFormData({...formData, leaderboard: e.target.value})}>
            <option default value="ranked">Ranked</option>
            <option value="worldTour">World Tour</option>
          </Form.Select>
        </Form.Group>
        <Button variant="primary" type="button" onClick={onClickBtn}>
          Submit
        </Button>
    </Form>
    {validated && <div>
      <Form.Label>Copy paste this link in a OBS browser source</Form.Label>
      {copied && <Badge pill bg="success" className="ms-3">
        Copied !
      </Badge>}
      <InputGroup className="mb-2 mt-2" >
          <Button variant="outline-secondary" id="button-addon1" onClick={copyToClipboard} className='align-middle'>
            {copied ? <FaClipboardCheck /> : <FaClipboard />}
          </Button>
          <Form.Control type="text" id="finalUrl" aria-describedby="basic-addon1" readOnly value={urlGenerated} />
      </InputGroup></div>}
    <div className='mb-3'><h4>Preview</h4>
    {formData.leaderboard == "ranked" && <div className="componentBase" style={{color: formData.textColor, fontFamily : formData.fontFamily}}>
                        <div className="imageLeague"><img src={"https://storage.googleapis.com/embark-discovery-leaderboard/img/thumbs/diamond-2-thumb.png"}/></div>
                        <div className="infos" style={{backgroundColor : formData.backgroundColor, borderColor : formData.borderColor, borderWidth: formData.borderWidth + "px"}}>
                            <div className="league">Diamond 2</div>
                            <div className="rank"><span className="desc">Rank</span> 000</div>
                            <div className="positive"><span className="desc">24h</span> 000</div>
                        </div>
                    </div>}
    {formData.leaderboard == "worldTour" && 
                              <div className="componentBase" style={{color: formData.textColor, fontFamily : formData.fontFamily}}>
                                <div className="infos-wt" style={{backgroundColor : formData.backgroundColor, borderColor : formData.borderColor, borderWidth: formData.borderWidth + "px"}}>
                                  <div className="cash">{formatter.format(100000000)}</div>
                                  <div className="description"><span className="desc">Rank</span>1234<span className="desc right-desc">Name</span>PlayerName</div>
                              </div>
                          </div>}
                    </div>

    
    
    </Container>
  );
}

export default FormInfo;
